/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { Component } from "react";
import { Popover, Button, Modal, Select, Switch } from "antd";
import Storage from "../../../services/local-store";
import postService from "../../../services/httpService";
import * as moment from "moment";
import * as R from "ramda";
import userTrackService from "../../../services/usertrack-service";
import { CHECKIN_DELAY_TIME } from "../../../constants/app-constants";
import PatientCard from "../../../modules/common/PatientCard";
import patientIcon from "../../../assets/images/Patient.svg";
import userIcon from "../../../assets/images/user_color.svg";
import service from "../../../assets/images/service.svg";
import { InfoCircleOutlined } from '@ant-design/icons';
import { w3cwebsocket as WebSocket } from 'websocket';
import networkList from "./../../../constants/networkList.jsx";
const { websocket_url1 } = networkList;



const url = new URL(websocket_url1);
const host = url.host;
const socket = new WebSocket('ws://'+host);


const { confirm } = Modal;
class AsignCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      date: new Date(),
      clicked: false,
      ModalText: "Content of the modal",
      visible: false,
      confirmLoading: false,
      tatmodalvisible: false,
      TATexceededTime: "",
      TATexceededReason: "",
      checkindelaymodalvisible: false,
      statecheckindelayTime: "",
      statecheckindelayReason: "",
      checkinDelayReasonsforDropdown: [],
      skipReasonsforDropdown: [],
      ModalError: false,
      ModalError1: false,
      skipmodalvisible: false,
      checkoutmodalvisible: false,
      stateskipReason: "",
      checkoutType: "",
      stateUnlockReason: "",
      stateRoomChangeReason:"",
      stateRoomNumber:"",
      unlockReasonsforDropdown: [],
      unlockmodalvisible: false,
      roomchangemodalvisible:false,
      rooms:[],
    };
  }

  componentDidMount() {
    // console.log("This.props in didmount",this.props)

      socket.onopen = () => {
             console.log('WebSocket connection established.');
             // this.onStartQ(queueitem, "withoutassign")
             // socket.send("message sent to server");
          };
          socket.onmessage = (event) => {
            console.log("This.props in onmessage",this.props)
          // const Queuerefresh=new QueuepatientDetailshell({item:this.state.item});
          // const Operatorview=new OperatorView();
              const message = event.data;
              let obj=JSON.parse(message);
              console.log(`Received message from server: ${message}`);
              console.log("acttion=",message.action);
              if(message==='{"data":"doctorbreak"}'){
                console.log("doctorbreak");
                console.log(message);
                this.props.refreshData();
              }
              else if(message==='{"data":"queuetransfer"}' || message==='{"data":"remove"}' || message==='{"data":"assign"}'|| message==='{"data":"doctordropdown"}'){
                console.log("queuetransfer");
                console.log(message);
                this.props.refreshData();
              }
              else if(obj.action==='remove' || obj.action==='patientroomchange'){
                console.log("remove operation",obj.data);
                this.props.refreshData();
                //this.props.refreshSingleQueue(obj.data, obj.action);
              }
          else{
            // console.log("remaining optionssssss");
            // console.log("this.props in assign in server",this.props);
            // console.log("action",obj,obj.action,obj.data);
              this.props.refreshSingleQueue(obj.data, obj.action,obj);
              this.props.deActivateLoader();
              //this.props.refreshData();
      
          }
              // Operatorview.deActivateLoader();
              // Operatorview.setlastRefreshedAt(moment());
           }
         
          
         socket.onclose = () => {
             console.log('WebSocket connection closed.');
           
           };
            socket.onerror = (error) => {
             console.error('WebSocket error:', error);
            }; 
       

     
    // this.isTimeexcess();
    // this.interval = setInterval(() => this.isTimeexcess(), 60000);

    // this.props.isvitalsRequire_nullornot(
    //   this.props.item && this.props.item.is_vitals_require
    // );

    this.getDelayReasonsforDropdown();
    this.getSkipReasonsforDropdown();
    this.getUnlockReasonsforDropdown();
  }
 
  

  hide = () => {
    this.setState({
      clicked: false,
    });
  };

  componentWillUnmount() {
    //clearInterval(this.interval);
  }

  // isTimeexcess(){
  //     let item = this.props.item;
  //     if(item.has_appointment === '1'){
  //         let isExceed = moment(new Date(item.appointment_date)).isBefore(moment(new Date()));
  //         if(isExceed){
  //             this.setState((state)=>({exceed:isExceed}));
  //         }
  //     }
  // }

  handleClickChange = (visible) => {
    this.setState({
      clicked: visible,
    });
  };
  removePatientFromQueue() {
    this.hide();
    let curthis = this;
    confirm({
      title:
        "This will remove the patient from the queue and move to the new patients' list. Still, want to remove?",
      onOk() {
        // console.log("OK");
        let currentObj = curthis.props.item;
     let QueueList = curthis.props.singleQueueList;
        let billingPatients = Storage.getJson("billingPatients");
        //console.log(currentObj);
        QueueList = QueueList.filter((s) => s.display_status != "1");
        QueueList.forEach((item1) => {
          if (item1.roomnumber === curthis.props.queueitem.roomnumber) {
            curthis.props.activateLoader();
            let obj = {
              patientId: currentObj.id,
              queueListId: item1.queuelistid,
            };
            let cancelObj = {
              appointement_id: currentObj.fk_appointment_id,
              reason: "11",
            };
            let Userlogobj = {
              user: JSON.parse(Storage.get("user")),
              action: "remove patient from queue",
              date: new Date(),
              meta: obj,
            };
            userTrackService(Userlogobj);
            postService("removePatientFromQueue", "POST", { data: obj }).then(
              (res) => {
                let Userlogobjres = {
                  user: JSON.parse(Storage.get("user")),
                  action: "remove patient from queue - response",
                  date: new Date(),
                  meta: res,
                };
                userTrackService(Userlogobjres);
                //curthis.props.refreshData();
                if (socket.readyState === WebSocket.OPEN) {
                  console.log('WebSocket connection established Checkin Checkin.');
                  // this.onStartQ(queueitem, "withoutassign")
                  const jsonString = JSON.stringify({data:obj,action:"remove"});
                  socket.send(jsonString);
                };
                // curthis.props.refreshSingleQueue(obj, "remove");
                // curthis.props.refreshData();
                // curthis.props.deActivateLoader();

                // postService("cancelAppointments", "POST", {
                //   data: cancelObj,
                // }).then((res) => {
                //   curthis.props.refreshData();
                //   curthis.props.refreshSingleQueue(obj, "remove");
                // });
                //if (res) {
                //this.hide();
                //  this.props.deActivateLoader();
                //}
              }
            );
          }
        });
      },
      onCancel() {
        // console.log("Cancel");
      },
    });

    //this.props.refreshData(QueueList, billingPatients);
  }
  skipPatientFromQueue() {
    this.setState({ ModalText: "Choose the reason for skip" });
    this.hide();
    this.showSkipModal();
  }
  getCheckoutReason(){
    this.setState({ ModalText: "Choose type of Check Out" });
    this.hide();
    this.showCheckOutModal();
  }
  // sendMessageAndWaitForResponse = (socket, message) => {
  //   return new Promise((resolve, reject) => {
  //     const handleMessage = (event) => {
  //       // Resolve the promise with the received message
  //       resolve(event.data);
  //       // Remove the event listener once we have received the message
  //       socket.removeEventListener('message', handleMessage);
  //     };
  
  //     const handleError = (error) => {
  //       // Reject the promise if there's an error
  //       reject(error);
  //       socket.removeEventListener('error', handleError);
  //     };
  
  //     // Add event listeners for message and error
  //     socket.addEventListener('message', handleMessage);
  //     socket.addEventListener('error', handleError);
  
  //     // Send the message
  //     socket.send(message);
  //   });
  // };
  serviceCallForSkip() {
    if (this.state.stateskipReason != "") {
      this.setState({ skipmodalvisible: false });
      let currentObj = this.props.item;
      console.log("Check Out", currentObj);
      let QueueList = this.props.singleQueueList || [];
      QueueList = QueueList.filter((s) => s.display_status != "1");
      console.log("Check Out111", QueueList);
      QueueList.forEach((skipitem1) => {
        if (skipitem1.roomnumber === this.props.queueitem.roomnumber) {
          console.log("Check Out222", skipitem1.patients);
        
          let obj = {
            patientId: currentObj.id,
            queueListId: skipitem1.queuelistid,
            skip_reason_id: this.state.stateskipReason,
            current_workflow_stage_id: currentObj.current_workflow_stage_id,
            "skip":"5"
          };
          this.props.activateLoader();
          let Userlogobj = {
            user: JSON.parse(Storage.get("user")),
            action: "skip patient from queue",
            date: new Date(),
            meta: obj,
          };
          userTrackService(Userlogobj);
          postService("skipPatient", "POST", { data: obj }).then((res) => {
            let Userlogobjres = {
              user: JSON.parse(Storage.get("user")),
              action: "skip patient from queue - response",
              date: new Date(),
              meta: res,
            };
            userTrackService(Userlogobjres);
            //if (res) {
            //  this.props.deActivateLoader();
            //this.props.refreshData();
            if (currentObj.current_workflow_stage_id == "3") {
              if (socket.readyState === WebSocket.OPEN) {
                 // this.onStartQ(queueitem, "withoutassign")
                // const jsonString = JSON.stringify(obj);
                const jsonString = JSON.stringify({data:obj,action:"skip"});

                socket.send(jsonString);
                console.log("111",jsonString);
              };
              //this.props.refreshSingleQueue(obj, "skip");
            } else {
              if (socket.readyState === WebSocket.OPEN) {
                // this.onStartQ(queueitem, "withoutassign")
                const jsonString = JSON.stringify({data:obj,action:"checkinskip"});

                // const jsonString = JSON.stringify(obj);
                socket.send(jsonString);
                console.log("1112",jsonString);

              };
              //this.props.refreshSingleQueue(obj, "checkinskip");
            }

            //}
          });
        }
      });
      this.hide();
    } else {
      this.setState({ ModalError: true });
    }
  }
   changePatientStatustoCheckin(value) {
    // console.log("changePatientStatuscheckin");
    // console.log("changePatientStatuscheckin props", this.props);
    // console.log("changePatientStatuscheckin value", value);
    // console.log("changePatientStatuscheckin queueitem", this.props.queueitem);
    // console.log(
    //   "changePatientStatuscheckin singleQueueList",
    //   this.props.singleQueueList
    // );
  
    let currentObj = this.props.item;
    // console.log("%%%%%%%%%%%%$$$$$$$$$$$$$$$$$#############&&&&&&&&&",currentObj,this.props.queueitem);
    let QueueList = this.props.singleQueueList || [];
    QueueList = QueueList.filter((s) => s.display_status != "1");
    // console.log("%%",this.props.queueitem.doctorname,this.props.queueitem.queue_doctor_id,currentObj.service_name,currentObj.service_id);
    let served_doctor_id=null;
    let served_doctor_name=null;
    if(this.props.queueitem.queue_doctor_id!=currentObj.service_id){
      served_doctor_id=this.props.queueitem.queue_doctor_id; 
      served_doctor_name=this.props.queueitem.doctorname;  
    }
    QueueList.forEach((item1) => {
      if (item1.roomnumber === this.props.queueitem.roomnumber) {
        let checkWorkflowStageobj = R.find(
          R.propEq("current_workflow_stage_id", "4"),
          item1.patients
        );
        let first_patient_id=item1.patients[0].id || '';
        // console.log("checkin...");
        // console.log(item1);
        // console.log(checkWorkflowStageobj);

       
        let obj = {
          served_doctor_name:served_doctor_name,
          served_doctor_id:served_doctor_id,
          appointment_id:currentObj.appointment_id,
          patientId: currentObj.id,
          queueListId: item1.queuelistid,
          doctor_id: item1.queue_doctor_id,
          delay_reason_id: this.state.statecheckindelayReason,
          delay_time: this.state.statecheckindelayTime,
          queue_delay: null,
        };
        if (!R.isNil(checkWorkflowStageobj)) {
          this.setState({
            ModalText: "You cannot Check-In two patients at a time.",
          });
          this.showModal();
        } else {
          // console.log("new checkin...");
          // let { appointment_date, service_time, first_patient_flag ,fromqueue_ordered_id,} =
          let { appointment_date, service_time, id } =
            currentObj;
          if (appointment_date !== undefined && appointment_date !== null && appointment_date !== "") {
            let startDate = moment(new Date(appointment_date));
            let endDate = moment(new Date());
            startDate = moment(startDate);
            endDate = moment(endDate);
            let checkindelay = endDate.diff(startDate, "minutes", true);
            let checkindelayint = parseInt(checkindelay);
            if (checkindelayint > 0) {
              var cdt_time = new Date();
              var s = moment(cdt_time, "hh:mm A")
                .add(parseInt(service_time), "m")
                .format("hh:mm A");
              obj.queue_delay = s;
            }
            // if (first_patient_flag == "1"||fromqueue_ordered_id==null) {
              if (first_patient_id == id) {
              // console.log("direct 1st patient checkin..");
              this.serviceCallForCheckIn(obj);
            } 
            else {
              // console.log("Reason for queue order deviation");
              this.setState({
                ModalText: "Reason for queue order deviation",
                statecheckindelayTime: checkindelayint,
              });
              this.showCheckinDelayModal();
            }
          } 
          else {
            // console.log("No Appointment.");
            // this.serviceCallForCheckIn(obj);
            // if (first_patient_flag == "1" ||fromqueue_ordered_id==null) {
              if (first_patient_id == id) {
              // console.log("direct 1st patient checkin..");
              this.serviceCallForCheckIn(obj);
            } 
            else {
              // console.log("Reason for queue order deviation");
              this.setState({
                ModalText: "Reason for queue order deviation",
                statecheckindelayTime: null,
              });
              this.showCheckinDelayModal();
            }
          }
        }
      }
    });
  }
 
  serviceCallForCheckIn(obj) {
    // console.log("Check in obj.....");
    // console.log(obj);
   
    // if (socket.readyState === WebSocket.OPEN) {
      //   // this.onStartQ(queueitem, "withoutassign")
    //   socket.send("message sent to  checkin checkin server");
    // };
    this.setState({ checkindelaymodalvisible: false });
    this.props.activateLoader();
    let Userlogobj = {
      user: JSON.parse(Storage.get("user")),
      action: "checkin",
      date: new Date(),
      meta: obj,
    };
    userTrackService(Userlogobj);
    postService("changePatientWorkflowStageTocheckIn", "POST", {
      data: obj,
    }).then((res) => {
      console.log("---userObject---",res);
      let Userlogobjres = {
        user: JSON.parse(Storage.get("user")),
        action: "checkin - response",
        date: new Date(),
        meta: res,
      };
      userTrackService(Userlogobjres);
     if(res){
      console.log("rrrrrrreeeeeess",res)
      if (socket.readyState === WebSocket.OPEN) {
      console.log('WebSocket connection established Checkin Checkin.');
      // this.onStartQ(queueitem, "withoutassign")
      const jsonString = JSON.stringify({data:obj,action:"checkin"});
      console.log("this.props in checkin inclient",this.props);
      //sendMessageAndWaitForResponse(socket,jsonString)
      // this.props.refreshSingleQueue(obj, "checkin");
      socket.send(jsonString);
      console.log("this.props in checkin in client after sent",this.props);
      socket.onmessage = (event) => {
         console.log("This.props in onmessage",this.props)
      // // const Queuerefresh=new QueuepatientDetailshell({item:this.state.item});
      // // const Operatorview=new OperatorView();
           const message = event.data;
           let obj=JSON.parse(message);
           console.log(`Received message from server: ${message}`);
           console.log("acttion=",message.action);
           if(message==='{"data":"doctorbreak"}'){
             console.log("doctorbreak");
             console.log(message);
             this.props.refreshData();
           }
           else if(message==='{"data":"queuetransfer"}' || message==='{"data":"remove"}' || message==='{"data":"assign"}'|| message==='{"data":"doctordropdown"}'){
             console.log("queuetransfer");
             console.log(message);
             this.props.refreshData();
           }
           else if(obj.action==='remove' || obj.action==='patientroomchange'){
             console.log("remove operation",obj.data);
             this.props.refreshData();
      //       //this.props.refreshSingleQueue(obj.data, obj.action);
           }
       else{
      //   // console.log("remaining optionssssss");
      //   // console.log("this.props in assign in server",this.props);
      //   // console.log("action",obj,obj.action,obj.data);
           this.props.refreshSingleQueue(obj.data, obj.action,obj);
           this.props.deActivateLoader();
      //     //this.props.refreshData();
  
       }
      //     // Operatorview.deActivateLoader();
      //     // Operatorview.setlastRefreshedAt(moment());
        }
    }
    ;}
      //socket.onmessage = (event) => {
      // const message = event.data;
      //   // if(message==Userlogobjres.user){
   //this.props.refreshSingleQueue(obj, "checkin");
      //   }
       //   // Handle incoming messages from the server as needed
      // };
      // socket.onclose = () => {
      
      // }
      //  socket.onerror = (error) => {
      //   console.error('WebSocket error:', error);
      //  };
   
      //if (res) {
    
      console.log("deactivate loader34567890")
      //this.props.refreshData();
     
      //}
    });
  }
  
  checkinCallWithDelay(value) {
    if (this.state.statecheckindelayReason != "") {
      // console.log("changePatientStatuscheckin with delay");
      //console.log(this.props, value, this.props.queueitem)
      let currentObj = this.props.item;
      let QueueList = this.props.singleQueueList || [];
    let served_doctor_id=null;
    let served_doctor_name=null;
    if(this.props.queueitem.queue_doctor_id!=currentObj.service_id){
      served_doctor_id=this.props.queueitem.queue_doctor_id; 
      served_doctor_name=this.props.queueitem.doctorname;  
    }
      QueueList = QueueList.filter((s) => s.display_status != "1");
      let { service_time } = currentObj;
      QueueList.forEach((item1) => {
        if (item1.roomnumber === this.props.queueitem.roomnumber) {
          let checkWorkflowStageobj = R.find(
            R.propEq("current_workflow_stage_id", "4"),
            item1.patients
          );
          let obj = {
            served_doctor_name:served_doctor_name,
          served_doctor_id:served_doctor_id,
            patientId: currentObj.id,
            queueListId: item1.queuelistid,
            doctor_id: item1.queue_doctor_id,
            delay_reason_id: this.state.statecheckindelayReason,
            delay_time: this.state.statecheckindelayTime,
            queue_delay: null,
          };
          if (this.state.statecheckindelayTime > 0) {
            var cdt_time = new Date();
            var s = moment(cdt_time, "hh:mm A")
              .add(parseInt(service_time), "m")
              .format("hh:mm A");
            obj.queue_delay = s;
          }
          if (!R.isNil(checkWorkflowStageobj)) {
            this.setState({
              ModalText: "You cannot Check-In two patients at a time.",
            });
            this.showModal();
          } else {
            this.serviceCallForCheckIn(obj);
          }
        }
      });
    } 
    else {
      this.setState({ ModalError: true });
    }
  }
  changePatientStatustoCheckout(value) {
    let currentObj = this.props.item;
    let QueueList = this.props.singleQueueList || [];
    QueueList = QueueList.filter((s) => s.display_status != "1");
if(this.state.checkoutType !=""){
      this.setState({ checkoutmodalvisible: false });
      if(this.state.checkoutType=="Review"){
          
            QueueList.forEach((item1) => {
              if (item1.roomnumber === this.props.queueitem.roomnumber) {
                let obj = {
                patientId: currentObj.id,
                appointment_id: currentObj.appointment_id,
                queueListId: item1.queuelistid,
                checkoutType:"Review",
                };
                this.props.activateLoader();
                let Userlogobj = {
                  user: JSON.parse(Storage.get("user")),
                  action: "checkout",
                  date: new Date(),
                  meta: obj,
                };
                userTrackService(Userlogobj);
                postService("changePatientWorkflowStageTocheckOut", "POST", {
                  data: obj,
                }).then((res) => {
                  let Userlogobjres = {
                    user: JSON.parse(Storage.get("user")),
                    action: "checkout - response",
                    date: new Date(),
                    meta: res,
                  };
                  userTrackService(Userlogobjres);
                  if (res) {
                  console.log("rrrrrrrrrrrrrreeeeeeeeeeeeerssssss",res)
                  this.props.deActivateLoader();
                  if (socket.readyState === WebSocket.OPEN) {
                    console.log('WebSocket connection established Checkin Checkin.');
                    // this.onStartQ(queueitem, "withoutassign")
                    const jsonString = JSON.stringify({data:obj,action:"checkout"});
                    socket.send(jsonString);
                  };}
                  //this.props.refreshData();
                   //this.props.refreshSingleQueue(obj, "checkout");
                  //}
                });
              }})
            
      }
      else{
    // let currentObj = this.props.item;
    // let QueueList = this.props.singleQueueList || [];
    // QueueList = QueueList.filter((s) => s.display_status != "1");
    QueueList.forEach((item1) => {
      if (item1.roomnumber === this.props.queueitem.roomnumber) {
        let checkin_time = currentObj.checkin_time;
        if (checkin_time !== undefined && checkin_time !== null) {
          let startDate = moment(new Date(checkin_time)).format("LT");
          let endDate = moment(new Date()).format("LT");
          startDate = moment(startDate);
          endDate = moment(endDate);
          let TATEx = endDate.diff(startDate, "minutes", true);
          let serviceGroupTime = this.props.queueitem.service_time;
          // console.log(startDate, endDate);
          if (parseInt(TATEx) > parseInt(serviceGroupTime)) {
            // console.log("tat exceeded");
            this.setState({
              ModalText: "TAT Exceeded by " + TATEx + " min",
              TATexceededTime: TATEx,
            });
            this.showTATModal();
          } else {
            // console.log("tat not exceeded");
            let obj = {
              patientId: currentObj.id,
              appointment_id: currentObj.appointment_id,
              queueListId: item1.queuelistid,
              checkoutType:"Normal",
            };
            // console.log(obj);
            this.props.activateLoader();
            let Userlogobj = {
              user: JSON.parse(Storage.get("user")),
              action: "checkout",
              date: new Date(),
              meta: obj,
            };
            userTrackService(Userlogobj);
            postService("changePatientWorkflowStageTocheckOut", "POST", {
              data: obj,
            }).then((res) => {
              let Userlogobjres = {
                user: JSON.parse(Storage.get("user")),
                action: "checkout - response",
                date: new Date(),
                meta: res,
              };
              userTrackService(Userlogobjres);
              if (res) {
              this.props.deActivateLoader();
              //this.props.refreshData();
              if (socket.readyState === WebSocket.OPEN) {
                console.log('WebSocket connection established Checkin Checkin.');
                // this.onStartQ(queueitem, "withoutassign")
                const jsonString = JSON.stringify({data:obj,action:"checkout"});
                socket.send(jsonString);
              };
              //  this.props.refreshSingleQueue(obj, "checkout");
              }
            });
          }
        }
      }
    });
  }}
   else {
    this.setState({ ModalError: true });
  }
  }
  drpEvent(item) {
    // console.log("ondropevent......");
    // console.log(item, this.props.itemindex);
    if (this.props.setLatestDropIndex !== undefined) {
      //console.log("------->",this.props.roomId);
      this.props.setLatestDropIndex(this.props.itemindex);
    }
  }
  sug(item) {
    // console.log("dragged item......");
    // console.log(item);
    if (this.props.setLatestCard !== undefined) {
      this.props.setLatestCard(item, this.props.roomId);
    }
  }
  renderTime(date) {
    return moment(date).format("hh:mm A");
  }

  renderDate(date) {
    return moment(date).format("MMM Do, YY");
  }
  showModal = () => {
    this.setState({
      visible: true,
    });
  };
  showTATModal = () => {
    this.setState({
      tatmodalvisible: true,
    });
  };
  showCheckinDelayModal = () => {
    this.setState({
      checkindelaymodalvisible: true,
      statecheckindelayReason: "",
      ModalError: false,
    });
  };
  showSkipModal = () => {
    this.setState({
      skipmodalvisible: true,
      stateskipReason: "",
      ModalError: false,
    });
  };
  showCheckOutModal = () => {
    this.setState({
      checkoutmodalvisible: true,
      checkoutType:"",
      ModalError: false,
    });
  };
  showUnlockModal = () => {
    this.setState({
      unlockmodalvisible: true,
      stateUnlockReason: "",
      ModalError: false,
    });
  };
  showRoomChangeModal = () => {
    this.setState({
      roomchangemodalvisible: true,
      stateRoomChangeReason: "",
      stateRoomNumber: "",
      ModalError: false,
      ModalError1: false,
    });
  };

  handleOk = () => {
    this.setState({
      confirmLoading: false,
      visible: false,
    });
  };
  TathandleOk = () => {
    this.setState({
      confirmLoading: false,
      tatmodalvisible: false,
    });
  };
  delayhandleOk = () => {
    this.setState({
      confirmLoading: false,
      checkindelaymodalvisible: false,
    });
  };
  skiphandleOk = () => {
    this.setState({
      confirmLoading: false,
      skipmodalvisible: false,
    });
  };
  checkouthandleOk = () => {
    this.setState({
      confirmLoading: false,
      checkoutmodalvisible: false,
    });
  };
  unlockhandleOk = () => {
    this.setState({
      confirmLoading: false,
      unlockmodalvisible: false,
    });
  };
  roomchangehandleOk = () => {
    this.setState({
      confirmLoading: false,
      roomchangemodalvisible: false,
    });
  };
  handleCancel = () => {
    this.setState({
      visible: false,
    });
  };
  TAThandleCancel = () => {
    this.setState({
      tatmodalvisible: false,
    });
  };
  delayhandleCancel = () => {
    this.setState({
      checkindelaymodalvisible: false,
    });
  };
  skiphandleCancel = () => {
    this.setState({
      skipmodalvisible: false,
    });
  };
  checkouthandleCancel = () => {
    this.setState({
      checkoutmodalvisible: false,
    });
  };
  unlockhandleCancel = () => {
    this.setState({
      unlockmodalvisible: false,
    });
  };
  roomchangehandleCancel = () => {
    this.setState({
      roomchangemodalvisible: false,
    });
  };
  getTATReason(value) {
    this.setState({ TATexceededReason: value });
  }
  getDelayReason(value) {
    this.setState({ statecheckindelayReason: value });
  }
  getSkipReason(value) {
    this.setState({ stateskipReason: value });
  }
  getCheckoutType(value){
    this.setState({ checkoutType: value });
  }
  getUnlockReason(value) {
    this.setState({ stateUnlockReason: value });
  }
  getRoomChangeReason(value) {
    this.setState({ stateRoomChangeReason: value });
  }
  getRoomNumber(value) {
    this.setState({ stateRoomNumber: value });
  }
  getDelayReasonsforDropdown() {
    postService("getCheckinDelayReasons", "GET", "").then((res) => {
      if (res.status) {
        this.setState({ checkinDelayReasonsforDropdown: res.data });
      }
    });
  }
  getSkipReasonsforDropdown() {
    postService("getSkipReasons", "GET", "").then((res) => {
      if (res.status) {
        this.setState({ skipReasonsforDropdown: res.data });
      }
    });
  }
  getUnlockReasonsforDropdown() {
    postService("getRoomChangeReasons", "GET", "").then((res) => {
      if (res.status) {
        this.setState({ unlockReasonsforDropdown: res.data });
      }
    });
  }

  saveTATExceededReason = () => {
    let currentObj = this.props.item;
    let QueueList = this.props.singleQueueList || [];
    QueueList = QueueList.filter((s) => s.display_status != "1");
    QueueList.forEach((item1) => {
      if (item1.roomnumber === this.props.queueitem.roomnumber) {
        let obj = {
          patientId: currentObj.id,
          queueListId: item1.queuelistid,
          TATexceededTime: this.state.TATexceededTime,
          TATexceededReason: this.state.TATexceededReason,
          checkoutType:"Normal",
        };
        // console.log(obj);
        let Userlogobj = {
          user: JSON.parse(Storage.get("user")),
          action: "checkout with TAT reason",
          date: new Date(),
          meta: obj,
        };
        userTrackService(Userlogobj);
        this.props.activateLoader();
        postService("changePatientWorkflowStageTocheckOut", "POST", {
          data: obj,
        }).then((res) => {
          let Userlogobjres = {
            user: JSON.parse(Storage.get("user")),
            action: "checkout with TAT reason - response",
            date: new Date(),
            meta: res,
          };
          userTrackService(Userlogobjres);
          //if (res) {
          this.TAThandleCancel();
          //this.props.refreshData();
          if (socket.readyState === WebSocket.OPEN) {
            console.log('WebSocket connection established Checkin Checkin.');
            // this.onStartQ(queueitem, "withoutassign")
            const jsonString = JSON.stringify({data:obj,action:"tatexceed"});
            socket.send(jsonString);
          };
          //this.props.refreshSingleQueue(obj, "tatexceed");
          //}
        });
      }
    });
  };
  unlockPatientFromQueue() {
    this.setState({ ModalText: "Choose the reason for unlock room" });
    this.hide();
    this.showUnlockModal();
  }
  changePatientRoomFromQueue() {
    this.setState({ ModalText: "Choose the reason for changing room" });
    this.hide();
    this.showRoomChangeModal();
     const rooms=this.props.department_ids.filter( item=>item.dept_ids && item.doctor_name && this.props.item.departmentid && item.dept_ids.includes(this.props.item.departmentid));

     
    if(rooms){
this.setState({rooms:rooms});
    }
  }
  serviceCallForUnlock() {
    if (this.state.stateUnlockReason != "") {
      this.setState({ unlockmodalvisible: false });
      let currentObj = this.props.item;
      this.props.activateLoader();
      let obj = {
        patientId: currentObj.id,
        status: true,
        queuelistid: this.props.queueitem.queuelistid || "",
        roomnumber: this.props.queueitem.roomnumber || "",
        reason: this.state.stateUnlockReason || "",
      };
      let Userlogobj = {
        user: JSON.parse(Storage.get("user")),
        action: "Allow patient to different room",
        date: new Date(),
        meta: obj,
      };
      userTrackService(Userlogobj);
      postService("allowPatientBetweenRooms", "POST", { data: obj }).then(
        (res) => {
          let Userlogobjres = {
            user: JSON.parse(Storage.get("user")),
            action: "Allow patient to different room- response",
            date: new Date(),
            meta: res,
          };
          userTrackService(Userlogobjres);
          //this.props.refreshData();
          this.props.refreshSingleQueue(obj, "unlock");
        }
      );
    } else {
      this.setState({ ModalError: true });
    }
  }
  serviceCallForRoomChange() {
    if (this.state.stateRoomChangeReason == "" ){
      this.setState({ ModalError: true });}
    else if(this.state.stateRoomNumber == ""){
      this.setState({ ModalError1: true }); }
    else{
   const new_doctor_data=this.state.rooms.filter(item=>item.quelist_id==this.state.stateRoomNumber);
      this.setState({ roomchangemodalvisible: false });
 
       let currentObj = this.props.item;
       this.props.activateLoader();
       let obj = {
        patientId: currentObj.id,
        status: true,
        new_queuelistid:this.state.stateRoomNumber||"",
        new_doctor_name:new_doctor_data[0].doctor_name||"",
        queuelistid: this.props.queueitem.queuelistid || "",
        roomnumber: this.props.queueitem.roomnumber || "",
      reason: this.state.stateRoomChangeReason || "",
      };
     
      let Userlogobj = {
        user: JSON.parse(Storage.get("user")),
        action: "Allow patient to different room",
        date: new Date(),
        meta: obj,
      };
       userTrackService(Userlogobj);
      
      postService("allowPatientBetweenRooms", "POST", { data: obj }).then(
        (res) => {
          let Userlogobjres = {
            user: JSON.parse(Storage.get("user")),
            action: "Allow patient to different room- response",
            date: new Date(),
            meta: res,
          };
          userTrackService(Userlogobjres);
          this.props.refreshData();
          if (socket.readyState === WebSocket.OPEN) {
            console.log('WebSocket connection established Checkin Checkin.');
            // this.onStartQ(queueitem, "withoutassign")
            const jsonString = JSON.stringify({data:obj,action:"patientroomchange"});
            socket.send(jsonString);
          };
           //this.props.refreshSingleQueue(obj, "fromroomChange");
      //     let obj1 = {
      //       patientId: currentObj.id,
      //       status: true,
      //       queuelistid:this.state.stateRoomNumber||"",
      //       roomnumber: this.props.queueitem.roomnumber || "",
      //     reason: this.state.stateRoomChangeReason || "",
      //     };
      //     let Userlogobj1 = {
      //   user: JSON.parse(Storage.get("user")),
      //   action: "Allow patient to different room",
      //   date: new Date(),
      //   meta: obj1,
      // };
      // userTrackService(Userlogobj1);
      //      this.props.refreshSingleQueue(obj1, "toroomChange");
        }
      );
   
  }}
  // onAllowRoomChange(checked) {
  //     let currentObj = this.props.item;
  //     this.props.activateLoader();
  //     let obj = {
  //         "patientId": currentObj.id,
  //         "status": checked,
  //         "queuelistid": this.props.queueitem.queuelistid || '',
  //         "roomnumber": this.props.queueitem.roomnumber || ''
  //     };
  //     let Userlogobj = {
  //         "user": JSON.parse(Storage.get('user')),
  //         "action": "Allow patient to different room",
  //         "date": new Date(),
  //         "meta": obj
  //     }
  //     userTrackService(Userlogobj);
  //     postService('allowPatientBetweenRooms', 'POST', { "data": obj }).then(res => {
  //         let Userlogobjres = {
  //             "user": JSON.parse(Storage.get('user')),
  //             "action": "Allow patient to different room- response",
  //             "date": new Date(),
  //             "meta": res
  //         }
  //         userTrackService(Userlogobjres);
  //         this.props.refreshData();
  //     });
  // }
  cIncOut = () => {
    let item = this.props.item;
    let {
      checkin_eligibility,
      checkout_eligibility,
      skip_eligibility,
      queue_type,
    } = this.props.queueitem;
    let QType = this.props.queueitem && queue_type;
    return (
      <>
    
        {this.props.viewtype == "doctor" ? (
          item.status === "3" ? (
            <button disabled={true}>C-IN</button>
          ) : item.status === "4" ? (
            <button disabled={true}>C-OUT </button>
          ) : (
            ""
          )
        ) : item.status === "3" ? (
          this.props.viewtype == "technician" &&
          checkin_eligibility == "technician" ? (
            <button
              className={
                item.bill_cancel_status == "YES"
                  ? "text-cancelled-disable"
                  : "text-checkin"
              }
              onClick={this.changePatientStatustoCheckin.bind(this, "checkin")}
              disabled={item.bill_cancel_status == "YES" && true}
            >
              {item.bill_cancel_status == "YES" ? "BIL-CAN" : "C-IN"}
            </button>
          ) : this.props.viewtype != "technician" &&
            (checkin_eligibility == null ||
              checkin_eligibility == "secretary") ? (
            QType === "Radiology" ? (
              <button
                className={
                  item.bill_cancel_status == "YES"
                    ? "text-cancelled-disable"
                    : "text-checkin"
                }
                onClick={this.changePatientStatustoCheckin.bind(
                  this,
                  "checkin"
                )}
                disabled={item.bill_cancel_status == "YES" && true}
              >
                {item.bill_cancel_status == "YES" ? "BIL-CAN" : "C-IN"}
              </button>
            ) : (
              QType === "OPD Consultation" && (
                <button
                  className=
                  {item.bill_cancel_status == "YES"
                    ? "text-cancelled-disable"
                    :item.review_patient=='1' && item.is_vitals_done === "YES"
                    ?"text-reports"
                    : item.is_vitals_require === "YES"
                    ? item.is_vitals_done === "YES"
                      ? "text-checkin"
                      : "text-vitals"
                    : "text-checkin"}
                  onClick={this.changePatientStatustoCheckin.bind(
                    this,
                    "checkin"
                  )}
                  disabled={
                    (item.bill_cancel_status == "YES" ||
                      (item.is_vitals_require === "YES" &&
                        item.is_vitals_done !== "YES")) &&
                    true
                  }
                >
                  {item.bill_cancel_status == "YES"
                    ? "BIL-CAN"
                    : item.is_vitals_require === "YES"
                    ? item.is_vitals_done === "YES"
                      ? "C-IN"
                      : "VITALS"
                    : "C-IN"}
                </button>
              )
            )
          ) : (
            <button
              className={
                item.bill_cancel_status == "YES"
                  ? "text-cancelled-disable"
                  : "text-checkin-disable"
              }
              disabled={true}
            >
              {item.bill_cancel_status == "YES" ? "BIL-CAN" : "C-IN"}
            </button>
          )
        ) : item.status === "4" ? (
          this.props.viewtype == "technician" &&
          checkout_eligibility == "technician" ? (
            <button
              className={
                item.bill_cancel_status == "YES"
                  ? "text-cancelled-disable"
                  : "text-checkout"
              }
              onClick={this.getCheckoutReason.bind(this)}
              disabled={item.bill_cancel_status == "YES" && true}
            >
              {item.bill_cancel_status == "YES" ? "BIL-CAN" : "C-OUT"}
            </button>
          ) : this.props.viewtype != "technician" &&
            (checkout_eligibility == null ||
              checkout_eligibility == "secretary") ? (
            <button
              className={
                item.bill_cancel_status == "YES"
                  ? "text-cancelled-disable"
                  : "text-checkout"
              }
              onClick={this.getCheckoutReason.bind(this)}
              disabled={item.bill_cancel_status == "YES" && true}
            >
              {item.bill_cancel_status == "YES" ? "BIL-CAN" : "C-OUT"}
            </button>
          ) : (
            <button
              className={
                item.bill_cancel_status == "YES"
                  ? "text-cancelled-disable"
                  : "text-checkin-disable"
              }
              disabled={true}
            >
              {item.bill_cancel_status == "YES" ? "BIL-CAN" : "C-OUT"}
            </button>
          )
        ) : (
          ""
        )}
      </>
    );
  };
  render() {
    const Option = Select.Option;
    const {
      visible,
      confirmLoading,
      ModalText,
      tatmodalvisible,
      checkindelaymodalvisible,
      ModalError,
      ModalError1,
      statecheckindelayReason,
      stateskipReason,
      checkoutType,
      skipmodalvisible,
      checkoutmodalvisible,
      stateUnlockReason,
      stateRoomChangeReason,
      stateRoomNumber,
      unlockmodalvisible,
      roomchangemodalvisible,
    } = this.state;
    let item = this.props.item;
       let { checkin_eligibility, checkout_eligibility, skip_eligibility } =
      this.props.queueitem;
  // console.log("%%%%%%%%",this.props);
    let draggableStatus;
    if (item.status === "3") {
      // draggableStatus = "true";
      draggableStatus = "true";
    } else if (item.status === "4") {
      draggableStatus = "false";
    }
    if (this.props.viewtype == "technician") {
      draggableStatus = "false";
    }
    if (this.props.viewtype == "doctor") {
      draggableStatus = "false";
    }
    let queueitemlength;
    if (
      this.props.queueitem.patients !== undefined &&
      this.props.queueitem.patients !== null
    ) {
      queueitemlength = this.props.queueitem.patients.length;
    }
    let QType = this.props.queueitem && this.props.queueitem.queue_type;
    const popupContent = (
      <div className="popup">
        <h4>
          More Options
          <img
            onClick={this.hide}
            src="/assets/images/icons/popup-close.png"
            alt="closeicon"
            draggable={false}
          />
        </h4>
        {queueitemlength - 1 !== this.props.itemindex || queueitemlength === 1 ? (
          this.props.viewtype == "technician" &&
          skip_eligibility == "technician" ? (
            <Button
              className="btn-gray"
              onClick={this.skipPatientFromQueue.bind(this)}
            >
              Skip
            </Button>
          ) : this.props.viewtype != "technician" &&
            (skip_eligibility == null || skip_eligibility == "secretary") ? (
            <Button
              className="btn-gray"
              onClick={this.skipPatientFromQueue.bind(this)}
            >
              Skip
            </Button>
          ) : (
            <button className="text-checkin-disable" disabled={true}>
              Skip
            </button>
          )
        ) : (
          ""
        )}
        {this.props.viewtype == "technician" ? (
          <button className="text-checkin-disable" disabled={true}>
            Remove
          </button>
        ) : (
          <Button
            className="btn-red"
            onClick={this.removePatientFromQueue.bind(this)}
          >
            Remove
          </Button>
        )}
        {/* {this.props.item.current_workflow_stage_id == 3?(
        <Button
          className="btn-gray"
          onClick={this.changePatientRoomFromQueue.bind(this)}
        >
          Change Room
        </Button>):""} */}

        {/* <Button
          className="btn-gray"
          onClick={this.unlockPatientFromQueue.bind(this)}
        >
          Unlock
        </Button> */}
      </div>
    );
    const patient_details = (
      <div>
        <p className="mb-0">
          Service Group :{" "}
          {item.bill_service_group ? item.bill_service_group : "--"}
        </p>
        <p className="mb-0">
          Service : {item.service_name ? item.service_name : "--"}
        </p>
        <p className="mb-0">
          Mobile No : {item.phonenumber ? item.phonenumber : "--"}
        </p>
        <p className="mb-0 text-capitalize">
          Emergency : {item.is_emergency ? item.is_emergency : "--"}
        </p>
        <p className="mb-0 text-capitalize">
          Bill Cancelled :{" "}
          {item.bill_cancel_status ? item.bill_cancel_status : "No"}
        </p>
        {QType === "OPD Consultation" && (
          // <div className="row m-0">
          //   <div className="col-8">
          //     {item.is_vitals_require && item.is_vitals_require && (
          //       <small className="text-danger">
          //         {item.is_vitals_done &&
          //           (item.is_vitals_done
          //             ? "Vitals Done"
          //             : "Vitals not yet done")}
          //       </small>
          //     )}
          //   </div>
          // </div>
          <>
            <p className="mb-0">
              Vitals Required :{" "}
              {item.is_vitals_require !== null ? item.is_vitals_require : "--"}
            </p>
            <p className="mb-0">
              Vitals Status :{" "}
              {item.is_vitals_require === "YES"
                ? item.is_vitals_done !== null
                  ? item.is_vitals_done === "YES"
                    ? "Done"
                    : "Not yet done"
                  : "Patient in Vitals Queue"
                : "--"}
            </p>
          </>
        )}
      </div>
    );
    let redLabel = false;
    // if (item.has_appointment === '1') {
    //     let fullslottime = this.props.fullslottime || '';
    //     let isExceed = moment(new Date(item.appointment_date)).isBefore(moment(new Date(fullslottime)));
    //     if (isExceed) {
    //         redLabel = true;
    //     } else {
    //         redLabel = false;
    //     }
    // }
// console.log("@#456789098765sd!@#$%^&)(",item);
    return (
      <div
     
        className={`pr-0 pl-3 pt-1 disable-text ${
          redLabel ? "time-exceed" : ""
        } ${item.checkinskip == "1" ? "skipcolor" : ""}`}
        draggable={draggableStatus}
        onDragStart={this.sug.bind(this, item)}
        onDrop={(e) => this.drpEvent.call(this, item)}
      >
       
        {/* <div className="PatientCard mr-1 pb-2 h-auto" style={{border:item.review_patient==1?"2px solid #85ccec":item.vitals_pending==1?"2px solid #08597c":"2px solid #d0e1e9"}}>
           */}
           {/* <div className="PatientCard mr-1 pb-2 h-auto" style={{backgroundColor:item.review_patient==1?"#cfd3d5":item.vitals_pending==1?"#d0e1e9":""}}>
           */}
           <div className="PatientCard mr-1 pb-2 h-auto">
          
          {/* <div className="row pt-1"> */}
          <div className="col pl-0"  >
            {QType === "OPD Consultation" && (
              <>
                {/* <div className="row m-0">
                  <div className="col-8">
                    {item.is_vitals_require && item.is_vitals_require && (
                      <small className="text-danger">
                        {item.is_vitals_done &&
                          (item.is_vitals_done
                            ? "Vitals Done"
                            : "Vitals not yet done")}
                      </small>
                    )}
                  </div>
                </div> */}
                <div className="row">
                <div className="col-8"  >
                    {item.review_patient && (
                      <small className="text-danger ml-2" >Review Patient</small>
                    )}
                  </div>
                  {/* <div className="col-8" >
                    {item.is_investigation && (
                      <small className="text-danger ml-2">Investigation</small>
                    )}
                  </div> */}
                </div>
              </>
            )}
            <div 
              className={`row ${
                QType === "OPD Consultation" && !item.is_investigation && !item.review_patient && "mt-2"
              }`}
            >
             
              <div className="col-8"  >
                <img
                  alt=""
                  src={patientIcon}
                  className="patientIcon"
                  draggable={false}
                />
                <span className="Patientname">
                  {item.name ? item.name : "--"}
                </span>
              </div>
              <div className="col-4 pr-1 text-right">
                <span class="time m-auto">{'WT: '}{item.waitingTAT}</span>
              </div>
            </div>
            <div className="row pl-2">
              <div className="col-9">
                
                <Popover
                  overlayClassName="popover-custom"
                  content={patient_details}
                  title=""
                >
                  {/* <Icon
                    type="info-circle"
                    style={{ color: "#ac7ab0" }}
                    className="uidIcon"
                    draggable={draggableStatus}
                  /> */}
                  <div draggable={draggableStatus}>
  <InfoCircleOutlined
    style={{ color: "#ac7ab0"}}
    className="uidIcon"
  />
           {item.umr ? item.umr : "--"}
</div>
                </Popover>
       
              </div>
              <div className="col-3 pl-0 ml-0">
                <div className="status q-p-d-list p-0 my-0">
                  {this.cIncOut()}
                </div>
              </div>
            </div>
            {QType === "Radiology" && (
              <div className="row pl-2">
                <div className="col-8">
                  <img
                    alt=""
                    src={userIcon}
                    className="uidIcon"
                    draggable={false}
                  />
                  <span className="PatientUid">
                    {item.service_name ? item.service_name : "--"}
                  </span>
                </div>
              </div>
            )}
            <div className="row pl-2">
              <div className={item.appointment_date !== null ? 'col-4' : 'col-8' }>
                <span className="Patientname align-bottom">
                  {/* {item.arrivaltime ? item.arrivaltime : "--"}{" "} */}
                  Arr:{" "}
                  {this.renderTime(item.arrivaltime) !== "Invalid date"
                    ? this.renderTime(item.arrivaltime)
                    : "HH:MM"}
                </span>
              </div>
            {item.appointment_date && 
            <div className="col-4">
                 <span className="Patientname align-bottom ml-0">
                  Apt:{" "}
                  {this.renderTime(item.appointment_date) !== "Invalid date"
                    ? this.renderTime(item.appointment_date)
                    : "HH:MM"}
                </span>
              </div>}
              <div className="col-4 text-right">
                {this.props.viewtype == "doctor" ? (
                  <p className="m-0">
                    {/* asd1 */}
                    <img
                      src="/assets/images/icons/more-icon.png"
                      alt="more"
                      srcSet=""
                      draggable={false}
                      width="15px"
                    />
                  </p>
                ) : (
                  <p className="m-0">
                    {/* asd2 */}
                    <Popover

                      content={popupContent}
                      trigger="click"
                      visible={this.state.clicked}
                      onVisibleChange={this.handleClickChange}
                    >
                      <img
                        src="/assets/images/icons/more-icon.png"
                        alt="more"
                        srcSet=""
                        draggable={false}
                        style={{ cursor: 'pointer' }}
                        width="15px"
                      />
                    </Popover>
                  </p>
                )}
              </div>
            </div>
            <div>
              <Modal
                visible={visible}
                // onOk={this.handleOk}
                confirmLoading={confirmLoading}
                onCancel={this.handleCancel}
                footer={[
                  <Button
                    key="submit"
                    type="primary"
                    // loading={loading}
                    onClick={this.handleCancel}
                  >
                    OK
                  </Button>,
                ]}
              >
                <p>{ModalText}</p>
              </Modal>
              {/* tat */}
              <Modal
                visible={tatmodalvisible}
                onOk={this.TathandleOk}
                confirmLoading={confirmLoading}
                onCancel={this.TAThandleCancel}
                footer={null}
              >
                <p>{ModalText}</p>
                <div className="col-12 mb-3">
                  <Select
                    defaultValue={this.state.TATexceededReason}
                    style={{ width: "100%" }}
                    onChange={this.getTATReason.bind(this)}
                  >
                    <Option value="Reason1">Reason 1</Option>
                    <Option value="Reason2">Reason 2</Option>
                    <Option value="Reason3">Reason 3</Option>
                    <Option value="Reason4">Reason 4</Option>
                  </Select>
                </div>
                <Button
                  type="primary"
                  onClick={this.saveTATExceededReason.bind(this)}
                >
                  Submit
                </Button>
              </Modal>

              <Modal
                visible={checkindelaymodalvisible}
                onOk={this.delayhandleOk}
                confirmLoading={confirmLoading}
                onCancel={this.delayhandleCancel}
                footer={null}
              >
                <p>{ModalText}</p>
                <div className="col-12 mb-3">
                  {ModalError ? (
                    <small className="text-danger">
                      Please select the reason.
                    </small>
                  ) : (
                    ""
                  )}
                  <Select
                    value={statecheckindelayReason}
                    style={{ width: "100%" }}
                    onChange={this.getDelayReason.bind(this)}
                  >
                    <Option value="">Select the Reason</Option>
                    {this.state.checkinDelayReasonsforDropdown.map((d, i) => {
                      return (
                        <Option value={d.id} key={i}>
                          {d.reason}
                        </Option>
                      );
                    })}
                  </Select>
                </div>
                <Button
                  type="primary"
                  onClick={this.checkinCallWithDelay.bind(this)}
                >
                  Submit
                </Button>
              </Modal>
{/* //SatYa */}
              <Modal
              className="checkoutModal"
                visible={checkoutmodalvisible}
                onOk={this.checkouthandleOk}
                confirmLoading={confirmLoading}
                onCancel={this.checkouthandleCancel}
                footer={null}
              >
                <p>{ModalText}</p>
                <div className="col-12 mb-3">
                  {ModalError ? (
                    <small className="text-danger">
                      Please select the Type.
                    </small>
                  ) : (
                    ""
                  )}
                  <Select
                    value={checkoutType}
                    style={{ width: "100%" }}
                    onChange={this.getCheckoutType.bind(this)}
                  >
                    <Option value="">Select type of checkout</Option>
                    <Option value="Review">Review Check Out</Option>
                    <Option value="Normal">Normal Check Out</Option>
                  </Select>
                </div>
                <Button
                  type="primary"
                  onClick={this.changePatientStatustoCheckout.bind(
                    this,
                    "checkout"
                  )}
                >
                  Submit
                </Button>
              </Modal>

              <Modal
                visible={skipmodalvisible}
                onOk={this.skiphandleOk}
                confirmLoading={confirmLoading}
                onCancel={this.skiphandleCancel}
                footer={null}
              >
                <p>{ModalText}</p>
                <div className="col-12 mb-3">
                  {ModalError ? (
                    <small className="text-danger">
                      Please select the reason.
                    </small>
                  ) : (
                    ""
                  )}
                  <Select
                    value={stateskipReason}
                    style={{ width: "100%" }}
                    onChange={this.getSkipReason.bind(this)}
                  >
                    <Option value="">Select the Reason </Option>
                    {this.state.skipReasonsforDropdown.map((d, i) => {
                      return (
                        <Option value={d.id} key={i}>
                          {d.reason}
                        </Option>
                      );
                    })}
                  </Select>
                </div>
                <Button
                  type="primary"
                  onClick={this.serviceCallForSkip.bind(this)}
                >
                  Submit
                </Button>
              </Modal>
              <Modal
                visible={unlockmodalvisible}
                onOk={this.unlockhandleOk}
                confirmLoading={confirmLoading}
                onCancel={this.unlockhandleCancel}
                footer={null}
              >
                <p>{ModalText}</p>
                <div className="col-12 mb-3">
                  {ModalError ? (
                    <small className="text-danger">
                      Please select the reason.
                    </small>
                  ) : (
                    ""
                  )}
                  <Select
                    value={stateUnlockReason}
                    style={{ width: "100%" }}
                    onChange={this.getUnlockReason.bind(this)}
                  >
                    <Option value="">Select the Reason</Option>
                    {this.state.unlockReasonsforDropdown.map((d, i) => {
                      return (
                        <Option value={d.id} key={i}>
                          {d.reason}
                        </Option>
                      );
                    })}
                  </Select>
                </div>
                <Button
                  type="primary"
                  onClick={this.serviceCallForUnlock.bind(this)}
                >
                  Submit
                </Button>
              </Modal>
              <Modal
                visible={roomchangemodalvisible}
                onOk={this.roomchangehandleOk}
                confirmLoading={confirmLoading}
                onCancel={this.roomchangehandleCancel}
                footer={null}
              >
                <p>{ModalText}</p>
                <div className="col-12 mb-3">
                  {ModalError ? (
                    <small className="text-danger">
                      Please select the reason.
                    </small>
                  ) : (
                    ""
                  )}
                  <Select
                    value={stateRoomChangeReason}
                    style={{ width: "100%" }}
                    onChange={this.getRoomChangeReason.bind(this)}
                  >
                    <Option value="">Select the Reason</Option>
                    
                        <Option value="Reason One">
                          Reason One
                        </Option>
                        <Option value="Reason Two">
                          Reason Two
                        </Option>
                        <Option value="Reason Three">
                          Reason Three
                        </Option>
                        <Option value="Reason Four">
                          Reason Four
                        </Option>
                      
                  </Select>
                  <p></p>
                  {ModalError1 ? (
                    <small className="text-danger">
                      Please select the Room.
                    </small>
                  ) : (
                    ""
                  )}
                  <Select
                    value={stateRoomNumber}
                    style={{ width: "100%" }}
                    onChange={this.getRoomNumber.bind(this)}
                  >
                    <Option value="">Select Room Number</Option>
                    {this.state.rooms.map((d, i) => {
                      return (
                        <Option value={d.quelist_id} key={i}>
                          {d.roomnumber}
                        </Option>)})}
                      
                  </Select>
                </div>
                <Button
                  type="primary"
                  onClick={this.serviceCallForRoomChange.bind(this)}
                >
                  Submit
                </Button>
              </Modal>
            </div>
          </div>
          {/* </div> */}
        </div>
      </div>
    );
  }
}

export default AsignCard;
export { socket };
